import { render, staticRenderFns } from "./UpdatePromotionAcc.vue?vue&type=template&id=6ff7c0c3&"
import script from "./UpdatePromotionAcc.vue?vue&type=script&lang=js&"
export * from "./UpdatePromotionAcc.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePromotionAcc.vue?vue&type=style&index=0&id=6ff7c0c3&prod&lang=css&"
import style1 from "./UpdatePromotionAcc.vue?vue&type=style&index=1&id=6ff7c0c3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports